import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

import HorizontalTeamCard from "examples/Cards/TeamCards/HorizontalTeamCard";

// Images
import team1 from "assets/images/team-5.jpg";
import team2 from "assets/images/bruce-mars.jpg";
import team3 from "assets/images/ivana-squares.jpg";
import team4 from "assets/images/ivana-square.jpg";

function Team() {
  return (
    <MKBox
      component="section"
      variant="gradient"
      bgColor="dark"
      position="relative"
      py={6}
      px={{ xs: 2, lg: 0 }}
      mx={-2}
    >
      <Container>
        <Grid container>
          <Grid item xs={12} md={8} sx={{ mb: 6 }}>
            <MKTypography variant="h3" color="white">
              Our Leadership Team
            </MKTypography>
            <MKTypography variant="body2" color="white" opacity={0.8}>
              Meet the dedicated researchers and administrators guiding our institution`s scientific endeavors and strategic vision.
            </MKTypography>
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={6}>
            <MKBox mb={1}>
              <HorizontalTeamCard
                image={team1}
                name="Dr. Emma Roberts"
                position={{ color: "info", label: "Director of Research" }}
                description="Leading our interdisciplinary research initiatives with over 20 years of experience in environmental science."
              />
            </MKBox>
          </Grid>
          <Grid item xs={12} lg={6}>
            <MKBox mb={1}>
              <HorizontalTeamCard
                image={team2}
                name="Prof. William Pearce"
                position={{ color: "info", label: "Chief Scientific Officer" }}
                description="Overseeing the scientific integrity and strategic direction of our research programs."
              />
            </MKBox>
          </Grid>
          <Grid item xs={12} lg={6}>
            <MKBox mb={{ xs: 1, lg: 0 }}>
              <HorizontalTeamCard
                image={team3}
                name="Dr. Ivana Flow"
                position={{ color: "info", label: "Head of International Collaborations" }}
                description="Fostering global partnerships to enhance the scope and impact of our research."
              />
            </MKBox>
          </Grid>
          <Grid item xs={12} lg={6}>
            <MKBox mb={{ xs: 1, lg: 0 }}>
              <HorizontalTeamCard
                image={team4}
                name="Dr. Marquez Garcia"
                position={{ color: "info", label: "Director of Innovation" }}
                description="Bridging research outcomes with practical applications to drive societal impact."
              />
            </MKBox>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Team;
